export default {
	SET: 'SET',
	SET_SEARCH_PARAM: 'SET_SEARCH_PARAM',
	SET_STATE: 'SET_STATE'
};
